export default class KnownError extends Error {
  public cause?: Error | string;

  public code: string;

  constructor(code: string, options?: { cause?: Error | string }) {
    super(code);
    this.code = code;
    this.cause = options?.cause;
    this.name = 'KnownError';
  }
}
